import { IXepLoaiHocTap } from "../../../model/response/category/IXepLoaiHocTap";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXepLoaiHocTapActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IXepLoaiHocTap[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IXepLoaiHocTap | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IXepLoaiHocTap,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eXepLoaiHocTapActionIds = generateActionTypeIds( eXepLoaiHocTapActionsObj, "XEP_LOAI_HOC_TAP");
export type IXepLoaiHocTapActionTypes = IGenericActionType<typeof eXepLoaiHocTapActionsObj,"XEP_LOAI_HOC_TAP">;